<div class="gpt-five-dialog">
  <button class="close-btn" (click)="close()" aria-label="Close dialog">×</button>

  <div class="header">
    <img src="assets/logos/openai.svg" alt="ChatGPT 5.2 Logo" class="mini-logo" />
    <h2>ChatGPT&nbsp;5.2</h2>
    <div class="sub">Refined GPT evolution — smarter, steadier, and more adaptive</div>
  </div>

  <div class="body">
    <p>
      <strong>ChatGPT&nbsp;5.2</strong> builds on the strengths of the GPT-5 series with sharper reasoning,
      improved reliability, and more consistent performance across complex tasks. It excels as a dependable
      AI partner for analysis, creation, and system-level assistance.
    </p>

    <ul>
      <li><strong>Enhanced reasoning depth:</strong> more accurate multi-step thinking, constraint handling, and decision support.</li>
      <li><strong>Improved context retention:</strong> maintains clarity and intent across long conversations and large inputs.</li>
      <li><strong>Stronger tool integration:</strong> more reliable coordination with search, code execution, and external APIs.</li>
      <li><strong>Higher output consistency:</strong> better adherence to required formats, schemas, and instructions.</li>
      <li><strong>Refined communication style:</strong> clearer explanations, reduced ambiguity, and polished professional tone.</li>
    </ul>

    <div class="optimal">
      <h3>Reasoning controls</h3>
      <ul>
        <li><strong>Auto:</strong> adaptive depth based on task complexity.</li>
        <li><strong>Instant:</strong> fastest responses with light reasoning.</li>
        <li><strong>Thinking:</strong> balanced reasoning for most tasks.</li>
        <li><strong>Pro:</strong> deeper, more thorough reasoning for high-stakes work.</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>Best when to use ChatGPT&nbsp;5.2</h3>
      <ul>
        <li>Complex problem solving, structured reasoning, and decision analysis</li>
        <li>Production-grade coding, refactoring, and technical validation</li>
        <li>Authoritative documentation, specifications, and executive summaries</li>
        <li>Extended workflows requiring stability and consistency over time</li>
        <li>AI-assisted operations that demand predictability and precision</li>
      </ul>
    </div>
  </div>
</div>
